$('.box-container-shadowable').on('mouseenter', function (item) {
    target = $(item.target);
    box = target.parents('.box-container-shadowable').length > 0 ? target.parents('.box-container-shadowable')[0] : target;
    $(box).addClass('shadow-lg');
});
$('.box-container-shadowable').on('mouseleave', function (item) {
    $('.shadow-lg').removeClass('shadow-lg');
});
/*
$('.zoomable').on('mouseenter', function ( item ) {
    var target = $(item.target);

    $(target).click();
});
$('.zoomable').on('mouseleave', function ( item ) {
    var target = $(item.target);

    $(target).click();
});
*/
